/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 企業の管理画面用 API
 * PR TIMES 企業の管理画面で使うAPI。basePathは今後変わる事も想定している。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { PressKitDocumentExtensionEnum } from './PressKitDocumentExtensionEnum';
import {
    PressKitDocumentExtensionEnumFromJSON,
    PressKitDocumentExtensionEnumFromJSONTyped,
    PressKitDocumentExtensionEnumToJSON,
} from './PressKitDocumentExtensionEnum';
import type { PressKitTag } from './PressKitTag';
import {
    PressKitTagFromJSON,
    PressKitTagFromJSONTyped,
    PressKitTagToJSON,
} from './PressKitTag';
import type { PressKitThumbnailUrls } from './PressKitThumbnailUrls';
import {
    PressKitThumbnailUrlsFromJSON,
    PressKitThumbnailUrlsFromJSONTyped,
    PressKitThumbnailUrlsToJSON,
} from './PressKitThumbnailUrls';

/**
 * プレスキット資料の詳細
 * @export
 * @interface PressKitDocuments
 */
export interface PressKitDocuments {
    /**
     * PressKit Image UUID(v4)
     * @type {string}
     * @memberof PressKitDocuments
     */
    id: string;
    /**
     * ファイルリソースが保存されたS3のURL、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PressKitDocuments
     */
    resourceUri: string;
    /**
     * 企業が登録したファイルの名前（キャプション）
     * @type {string}
     * @memberof PressKitDocuments
     */
    title: string;
    /**
     * 企業が登録したファイルの名前（title+extension）
     * @type {string}
     * @memberof PressKitDocuments
     */
    filename: string;
    /**
     * 企業が登録したファイルの説明文。設定無しは''になる。
     * @type {string}
     * @memberof PressKitDocuments
     */
    description: string;
    /**
     * 
     * @type {PressKitDocumentExtensionEnum}
     * @memberof PressKitDocuments
     */
    extension: PressKitDocumentExtensionEnum;
    /**
     * ファイルのサイズ（単位はbytes）
     * @type {number}
     * @memberof PressKitDocuments
     */
    fileSize: number;
    /**
     * 
     * @type {PressKitThumbnailUrls}
     * @memberof PressKitDocuments
     */
    thumbnailUrls: PressKitThumbnailUrls;
    /**
     * 画像のダウンロード用URL。別ドメイン。
     * @type {string}
     * @memberof PressKitDocuments
     */
    downloadUrl: string;
    /**
     * サムネイル画像が保存されたS3へのURL、https://prtimes-static-dev.s3.ap-northeast-1.amazonaws.com あるいは https://prtimes-static.s3.ap-northeast-1.amazonaws.com で始まることを検証している
     * @type {string}
     * @memberof PressKitDocuments
     */
    thumbnailUri: string;
    /**
     * 設定されているタグ一覧
     * @type {Array<PressKitTag>}
     * @memberof PressKitDocuments
     */
    tags: Array<PressKitTag>;
}

/**
 * Check if a given object implements the PressKitDocuments interface.
 */
export function instanceOfPressKitDocuments(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "resourceUri" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "filename" in value;
    isInstance = isInstance && "description" in value;
    isInstance = isInstance && "extension" in value;
    isInstance = isInstance && "fileSize" in value;
    isInstance = isInstance && "thumbnailUrls" in value;
    isInstance = isInstance && "downloadUrl" in value;
    isInstance = isInstance && "thumbnailUri" in value;
    isInstance = isInstance && "tags" in value;

    return isInstance;
}

export function PressKitDocumentsFromJSON(json: any): PressKitDocuments {
    return PressKitDocumentsFromJSONTyped(json, false);
}

export function PressKitDocumentsFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressKitDocuments {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'resourceUri': json['resource_uri'],
        'title': json['title'],
        'filename': json['filename'],
        'description': json['description'],
        'extension': PressKitDocumentExtensionEnumFromJSON(json['extension']),
        'fileSize': json['file_size'],
        'thumbnailUrls': PressKitThumbnailUrlsFromJSON(json['thumbnail_urls']),
        'downloadUrl': json['download_url'],
        'thumbnailUri': json['thumbnail_uri'],
        'tags': ((json['tags'] as Array<any>).map(PressKitTagFromJSON)),
    };
}

export function PressKitDocumentsToJSON(value?: PressKitDocuments | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'resource_uri': value.resourceUri,
        'title': value.title,
        'filename': value.filename,
        'description': value.description,
        'extension': PressKitDocumentExtensionEnumToJSON(value.extension),
        'file_size': value.fileSize,
        'thumbnail_urls': PressKitThumbnailUrlsToJSON(value.thumbnailUrls),
        'download_url': value.downloadUrl,
        'thumbnail_uri': value.thumbnailUri,
        'tags': ((value.tags as Array<any>).map(PressKitTagToJSON)),
    };
}

